import React,{useState} from "react";
import { RoundFloor,FromatNumberVIE } from '../../../utils/format'
import { isAuth } from "../../../helpers/general";
import { navigate } from 'gatsby';
import { actionCart } from '../../../service/cartService';
import { toast } from "react-toastify";
import { pushtracking } from "../../../service/trackingService";
import { checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist } from '../../../service/wishlistService';
import { useLocation } from "@reach/router";
import Img from "../../Images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ItemDefaultV2 =({item, showPriceRow, showpercen, hotdel})=>{
    const location = useLocation();
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const over=(e)=> {
        e.currentTarget.src = 'https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/heart_red.png';
    }
    const out=(e)=> {
        e.currentTarget.src = 'https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/heart.png';
    }


    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        toast.success('Thêm vào giỏ hàng thành công.');

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                            try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return(
        <div className="pading-item py-1">
            <div className="mant__content h-100 bg-white pb-3">
                <div className="mant__content--show position-relative overflow-hidden ">
                    {
                       showpercen === 'true' && 100 - percen >= 0 ?(<div className="sale position-absolute px-1 z-1">-{RoundFloor(100 - percen)}%</div>):(null)
                    }
                    <a href={'/' + item.linksp?.replace('/', '')}>
                        <div className="position-relative w-100 box-img">
                            {
                                hotdel === 'true' ? (
                                    <>
                                    <div className="img_thumbnail ">
                                        <Img imgTitle={item?.name} url={item.thumbnail?.replace('/origin', '/thumb')} className="" style=""/>
                                    </div>
                                    {/* <div className="img_thumbnail position-absolute w-100 top-0">
                                        <Img imgTitle={item?.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style=""/>
                                    </div> */}
                                    </>
                                ):(
                                    <>
                                    <div className="img_thumbnail ">
                                        <Img imgTitle={item?.name} url={item.thumbnail_mini} className="" style=""/>
                                    </div>
                                    {/* <div className="img_thumbnail position-absolute w-100 top-0">
                                        <Img imgTitle={item?.name} url={item.thumbnail_mini} className="" style=""/>
                                    </div> */}
                                    </>
                                )
                            }
                            
                        </div>
                    </a>
                    <div className="like position-absolute"><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="icon" src={wishlist || item.isFavorite ? ("/static/image/heart_red.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/heart.png")} alt="icon" onMouseOver={over} onMouseOut={out}/></div>
                    {
                        // && item?.namePromotion !== 'Mua là có quà' 
                        item?.namePromotion && item?.namePromotion !== '' ? (<div className="bixu position-absolute px-1">{item?.namePromotion}</div>):(null)
                    }

                </div>
                <div className="mant__content--info px-2">
                    <a href={'/' + item.linksp?.replace('/', '')}>
                        <h3 className="name">
                            { item?.name?.length > 55 ? ( (item?.name).substring(0, 55) +'...') :(item?.name)}
                        </h3>
                    </a>
                    <div className="row m-0">
                        <div className="col-10 p-0">
                            <span className="price fw-semibold ">
                                {FromatNumberVIE(item?.price['discount'])}<span className="text-decoration-underline fw-semibold">đ</span>
                            </span>
                            {
                                showPriceRow==='true' && (+item?.price['raw']) > (+item?.price['discount']) ?(
                                    <span className="price--sale text-decoration-line-through">
                                        {
                                            +item?.price['raw']>=1000000 ?(
                                                <>{FromatNumberVIE(JSON.stringify(item?.price['raw']).substring(0,5))}...</> 
                                            ):(
                                                <>{FromatNumberVIE(item?.price['raw'])}<span className="text-decoration-underline">đ</span></>
                                            )
                                        }
                                    </span>
                                ):(null)
                            }
                        </div>
                        <div className="col-2 p-0">
                            <div className="cart position-relative float-end pointer" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}>
                                <div className="img_cart "><img className="icon" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart.png" alt=""/></div>
                                <div className="img_cart position-absolute top-0 start-0"><img className="icon" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_red.png" alt=""/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}




const ItemGiftV2 =({item,showPriceRow})=>{
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 500);
        } else {
            navigate(uri);
            // if (item.sku.includes('C') === true) {
            //     window.localStorage.setItem('typepage', 'product');
            //     if(uri !== '/undefined'){
            //         navigate(uri);
            //     }
            // } else {
            //     let params = {
            //         items: [{
            //             product: item.sku,
            //             type: 'item',
            //             action: 'add',
            //             quantity: 1,
            //             promo_code: item.promoCode?? "",
            //             combo_code: item.combCode ?? '',
            //             uudai: item.uuDai,
            //             user_referral:  window.localStorage.getItem('userReferral'),
            //             id_share:   window.localStorage.getItem('idShare')
            //         }]
            //     }
            //     try {
            //         actionCart(params, window.localStorage.getItem('key')).then((response) => {
            //             if(+response.status === 200 && response.message?.length > 0){
            //             localStorage.removeItem("itemsCart");
            //             localStorage.setItem('itemsCart', JSON.stringify(response['message']));
            //             window.localStorage.setItem('reloadCart', true);
            //             toast.success('Thêm vào giỏ hàng thành công.');

            //             window.dataLayer = window.dataLayer || [];
            //             window.dataLayer.push({ ecommerce: null });
            //             window.dataLayer.push({
            //                     'event': 'add_to_cart',
            //                     'ecommerce': {
            //                     'currency': "VND",
            //                     'value': +item.price?.import,
            //                         'items': [
            //                         {
            //                             item_id: item.sku,
            //                             item_name: item.name,
            //                             price: +item.price?.import
            //                         }
            //                         ]
            //                     }
            //                 });
            //                 try{
            //                     pushtracking(window.localStorage.getItem('sessionId')??null,
            //                     window.localStorage.getItem('_id')??null,
            //                     window.localStorage.getItem('phone')??null ,
            //                     location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
            //                         console.log('send tracking');
            //                     });
            //                 }catch(e){console.log(e)}
            //             }
            //         });
            //     } catch (err) {
            //         console.log(err);
            //     }
            // }
        }
    }
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1
      };
      const settings1 = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    return(
        <div className="px-2 py-1">
            <div className="mant__content h-100 bg-white pb-3">
                <div className="mant__content--show position-relative overflow-hidden">
                    <div className="img--show">
                        <div className="img">
                            <Img imgTitle={item?.name} url={item.thumbnail} className="" style=""/>
                        </div>
                        {
                           item.thumbnail_gifts?.length>0?(
                            <div className="img position-absolute top-0 bg-white w-100 h-100 flex-column align-items-center py-3 ">
                            <div className="d-flex justify-content-center">
                                <div className="button--tang position-relative d-inline-block text-center rounded-pill text-white px-2">Tặng</div>
                            </div>
                            <div className="img--grif m-auto my-auto position-relative">
                                    {/* <Img imgTitle={'img gift'} url={item.thumbnail_gifts[0]} className="" style=""/> */}
                                    <Slider {...settings1}>
                                        { 
                                            item.thumbnail_gifts?.map((imggift, i)=>(
                                                <div>
                                                <a href={'/' + item.linksp?.replace('/', '')}>
                                                <Img key={i} imgTitle={item.name} url={imggift} className="" style=""/>
                                                </a>
                                                </div>
                                            ))
                                        }
                                        
                                    </Slider>
                                <div className="position-absolute icon--tang">
                                    <img  src="/static/image/icon_tang.svg" alt="icon"/>
                                </div>
                            </div>
                        </div>
                           ):(null) 
                        }
                        
                    </div>
                    {
                        item.thumbnail_gifts?.length>0?(
                            //img gift
                            <div className="box--grif row m-0 mx-2 row-gap-1 position-absolute end-0 h-auto">
                                <div className="col-12 p-0 pb-1">
                                    <div className="d-flex justify-content-center"><div className="button--tang d-inline-block text-center rounded-pill text-white px-2">Tặng</div></div>
                                </div>
                                <div className="col-12 p-0 mt-2">
                                    <div className="position-relative">
                                        <div className="icon--tang position-absolute end-0"><img  src="/static/image/icon_tang.png" alt=""/></div>
                                        <div className="w-100 img-gift">
                                        {/* <Img imgTitle={'img gift'} url={item.thumbnail_gifts[0]} className="" style=""/> */}
                                        <Slider {...settings}>
                                        { 
                                            item.thumbnail_gifts?.map((imggift, i)=>(
                                                <div>
                                                <Img key={i} imgTitle={'img gift'} url={imggift} className="" style=""/>
                                                </div>
                                            ))
                                        }
                                    </Slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ):(null)
                    }
                </div>
                <div className="mant__content--info px-2">
                    <a href={'/' + item.linksp?.replace('/', '')}>
                        <h3 className="name">
                        { item?.name?.length > 55 ? ( (item?.name).substring(0, 55) +'...') :(item?.name)}
                        </h3>
                    </a>
                    <div className="row m-0">
                         <div className="col-10 p-0">
                            <div className="row m-0">
                                <div className="col-6 p-0 my-auto ">
                                    <div className="price fw-semibold ">
                                    {FromatNumberVIE(item?.price['discount'])}<span className="text-decoration-underline fw-semibold">đ</span>
                                    </div>
                                </div>
                                <div className="col-6 p-0 my-auto">
                                {showPriceRow==='true'  && +item?.price['raw'] > +item?.price['discount']?(
                                        <div className="price--sale text-center text-decoration-line-through">
                                            {FromatNumberVIE(item?.price['raw'])}<span className="text-decoration-underline">đ</span>
                                        </div>
                                    ):(null)}
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-2 p-0">
                            <div className="cart position-relative float-end pointer" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}>
                                <div className="img_cart "><img className="icon" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart.png" alt=""/></div>
                                <div className="img_cart position-absolute top-0 start-0"><img className="icon" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_red.png" alt=""/></div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}


export {ItemDefaultV2,ItemGiftV2}